import script from "./Leads.vue?vue&type=script&setup=true&lang=js"
export * from "./Leads.vue?vue&type=script&setup=true&lang=js"

import "./Leads.vue?vue&type=style&index=0&id=fabd97dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fabd97dc"]])

export default __exports__